// extracted by mini-css-extract-plugin
export default {"header":"UsernamePrivacyModal_header__E8sBP","brand":"UsernamePrivacyModal_brand__pw4kT","li":"UsernamePrivacyModal_li__CXE2A","bold":"UsernamePrivacyModal_bold__mu2Ac"};